// angular
import {Component, OnInit, inject} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
// material angular
import {MatDialog} from "@angular/material/dialog";
// components
import {OrderListFiltersDialogComponent} from "./order-list-filters-dialog/order-list-filters-dialog.component";
import {TableComponent} from "@app/core/components/table/table.component";
import {AddButtonComponent} from "@app/core/components/add-button/add-button.component";
import {PayloadButtonComponent} from "@app/core/components/payload-button/payload-button.component";
// services
import {ScreenSizeService} from "@app/shared/services/screen-size.service";
import {OrderService} from "../shared/services/order.service";
// types
import {ScreenSizeType} from "@app/shared/types/screen-size.type";
import {ITableConfig} from "../../core/components/table/table-config.type";
import {Role} from "@app/shared/types/role.enum";
// directives
import {HasAccessDirective} from "@app/core/directives/has-access.directive";
import {HeaderPayloadDirective} from "@app/core/directives/header-payload.directive";
import {SortMenuGroup} from "@app/+customer/shared/types/customer-sort-menu.type";
import {customerSortOptionGroups} from "@app/+customer/shared/constants/customer-sort-options";

@Component({
  selector: "app-order-list",
  templateUrl: "./order-list.component.html",
  styleUrls: ["./order-list.component.scss"],
  standalone: true,
  imports: [
    TableComponent,
    AddButtonComponent,
    PayloadButtonComponent,
    HasAccessDirective,
    HeaderPayloadDirective,
  ],
})
export class OrderListComponent implements OnInit {
  public tableConfig: ITableConfig;
  public Role = Role;
  public pageId!: string;
  public customerSortOptionGroups: SortMenuGroup[] = customerSortOptionGroups;
  private _screenSize: ScreenSizeType;

  // dependencies
  private _orderService = inject(OrderService);
  private _activatedRoute = inject(ActivatedRoute);
  private _screenSizeService = inject(ScreenSizeService);
  private _spinner = inject(NgxSpinnerService);
  private _dialog = inject(MatDialog);

  constructor() {}

  ngOnInit() {
    this._activatedRoute.data.subscribe((data) => {
      if (data) {
        const pageId = data?.["id"];
        this.pageId = pageId;
      }
    });
    this._screenSizeService.screenSize$.subscribe(
      (size) => (this._screenSize = size)
    );
    this._activatedRoute.queryParams.subscribe(() => this._getList());
    this._orderService.updateList$.subscribe(() => this._getList());
  }

  private _getList() {
    this._orderService
      .getAllOrders({is_online: !!this.pageId})
      .subscribe((res) => {
        this.tableConfig = this._orderService.getOrdersTableConfig(res);
        this._spinner.hide();
      });
  }

  public bulkArchive() {
    this._orderService.bulkArchive();
  }

  public openFiltersModal() {
    this._dialog.open<OrderListFiltersDialogComponent>(
      OrderListFiltersDialogComponent,
      {
        maxWidth: "1000px",
        width: this._screenSize === "xSmall" ? "100vw" : "80vw",
        maxHeight: this._screenSize === "xSmall" ? "100vh" : "80vh",
      }
    );
  }
}
